import {sumByProperty, percentOfTotal} from '../../helpers';

const sumNonAllocatableOverheadSection = (
  nonAllocatableLineItems
  // AllocatableLineItems
) => {
  const Total = sumByProperty (
    nonAllocatableLineItems,
    'costsheetOverheadCost'
  );

  const NonAllocatableLineItemTypes = nonAllocatableLineItems.map (item => {
    return item.costsheetFactoryOverheadCostTypeName;
  });
  const allNonAllocatableLineItemTypes = [
    'Depreciation',
    'Labor',
    'Other',
    'Strategic',
    'Utilities',
  ];

  const missingNonAllocatableItemTypes = allNonAllocatableLineItemTypes
    .filter (i => {
      return NonAllocatableLineItemTypes.indexOf (i) < 0;
    })
    .map (itemType => {
      return {detail: itemType, cost: 0.00, percentOfTotal: '0.0%'};
    });
  //filter added in case the payload doesn't have Overhead Cost Type Name and has an ID. this will show the UI even if the payload for overhead line item details is not as expected.
  const nonAllocatableMappedItems = nonAllocatableLineItems
    .filter (i => {
      if (!i.costsheetFactoryOverheadCostTypeName) {
        return false;
      }
      return true;
    })
    .map (item => {
      return {
        detail: item.costsheetFactoryOverheadCostTypeName,
        cost: item.costsheetOverheadCost,
        percentOfTotal: percentOfTotal (Total, item.costsheetOverheadCost),
      };
    });
  return [...nonAllocatableMappedItems, ...missingNonAllocatableItemTypes];
};

export const sumOverheadSection = (cbdLineItems, Total) => {
  const summedTotal = sumByProperty (
    cbdLineItems.costsheetOverheadLineItemDetails,
    'costsheetOverheadCost'
  );
  return [
    ...sumNonAllocatableOverheadSection (
      cbdLineItems.costsheetOverheadLineItemDetails
      // cbdLineItems.costsheetAllocatableOverheadLineItemDetails
    ),
    {
      detail: 'Total',
      cost: summedTotal,
      percentOfTotal: percentOfTotal (Total, summedTotal),
    },
  ];
};



// WEBPACK FOOTER //
// ./src/dataMappingUIHelpers/subSectionMapping/overheadSection.js